import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface UtmParams {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_term: string | null;
  utm_content: string | null;
  utm_id: string | null;
}

const UTM_STORAGE_KEY = 'jornadajava';

function checkAndSaveUtms(search: string): UtmParams {
  const params = new URLSearchParams(search);
  const currentUtms = {
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    utm_term: params.get('utm_term'),
    utm_content: params.get('utm_content'),
    utm_id: params.get('utm_id')
  };

  // Verifica se há algum UTM na URL atual
  const hasUtms = Object.values(currentUtms).some(value => value !== null);

  if (hasUtms) {
    // Se há UTMs na URL, salva no localStorage
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(currentUtms));
    return currentUtms;
  }

  // Se não há UTMs na URL, tenta recuperar do localStorage
  const storedUtms = getStoredUtms();
  
  // Se não há UTMs armazenados, retorna os valores padrão
  if (Object.values(storedUtms).every(value => value === null)) {
    return currentUtms;
  }
  
  return storedUtms;
}

export function useUtmParams(): UtmParams {
  const location = useLocation();
  const [utmParams, setUtmParams] = useState<UtmParams>(() => {
    // Tenta capturar UTMs da URL inicial
    const initialUtms = checkAndSaveUtms(window.location.search);
    return initialUtms;
  });

  useEffect(() => {
    // Captura UTMs sempre que a URL mudar
    const newUtmParams = checkAndSaveUtms(location.search);
    setUtmParams(newUtmParams);
  }, [location.search]);

  // Adiciona um listener para capturar UTMs antes do unload
  useEffect(() => {
    const handleBeforeUnload = () => {
      checkAndSaveUtms(window.location.search);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return utmParams;
}

function getStoredUtms(): UtmParams {
  try {
    const stored = localStorage.getItem(UTM_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Erro ao ler UTMs do localStorage:', error);
  }

  return {
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_term: null,
    utm_content: null,
    utm_id: null
  };
} 